import React, { useRef, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { withRouter  } from 'react-router-dom';
import moment from 'moment';
import { addGood, setActiveModalAction, updateGood, fetchCategories, updateYumaposGoodMaps } from '../../action';
import { useOnClickOutside } from '../../hooks';
import { fromStore, modalsSelector } from '../../selectors';
import { getImageUrl, parseNumToFixed } from '../../utils/common';
import cn from 'classnames';
import ErrorContainer from '../../components/utils/ErrorContainer';
import Switch from '../../components/utils/Switch';
import Select from 'react-select';
import { MEASURES } from '../goods/constants';
import { isEmpty } from 'lodash';
import { TimeInput } from '../../components/utils/TimeInput';
import { YumaposGoodsMapInput } from '../../components/yumapos/YumaposGoodsMapInput';
import request from '../../action/utils/request';
import { daysWeek, optionsVat } from '../../constants/app';

const colourStyles = {
  control: (styles) => ({ ...styles, border: "1px solid #e2e5ec" }),
};

const SelectCategories = ({ selected, onChange, disabled }) => {
  const dispatch = useDispatch();
  const categories = useSelector(fromStore.categoryListSelector);
  const loading = useSelector(fromStore.loaderCategoriesSelector);

  const onChangeSelect = (value) => {
    onChange(value.id);
  };

  const selectedCategory = categories && selected ? categories.find((item) => item.id === selected) : null;

  useEffect(() => {
    isEmpty(categories) && dispatch(fetchCategories());
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [dispatch]);

  return (
    <div className="form-group">
        <label htmlFor="g-category" className="form-control-label">Категория *</label>
        <Select
            id="g-category"
            value={selectedCategory}
            options={categories}
            getOptionLabel={(item) => `${item.title}`}
            getOptionValue={(item) => item.id}
            onChange={onChangeSelect}
            isClearable={false}
            placeholder="Выберите категорию..."
            noOptionsMessage={() => 'Нет категорий'}
            disabled={disabled}
            isLoading={loading}
            styles={colourStyles}
        />
    </div>
  );
}

const optionsTypeMarked = [
  { value: 'markingCode', label: 'Разрешительный режим (Data Matrix)' },
  { value: 'horeca', label: 'Уведомительный режим (HoReCa)' },
];

function GoodModal({ history }) {
  const ref = useRef();
  const dispatch = useDispatch();
  const id = useSelector(modalsSelector).good;
  const loading = useSelector(fromStore.loaderModalGoodSelector);
  const loadingUpdate = useSelector(fromStore.loaderUpdateGoodSelector);
  const good = useSelector(fromStore.goodById(id));

  const [deleteSecondImage, setDeleteSecondImage] = useState(false);

  const loader = loading || loadingUpdate;

  const measureOptions = Object.entries(MEASURES).map(([value, label]) => ({ value, label }));
  const initData = good ? {
    name: good.name,
    article: good.article,
    category: good.category.id,
    active: good.active,
    price: good.price,
    recomended: good.recomended,
    oldPrice: good.oldPrice,
    gift: good.gift,
    hot: good.hot,
    vegan: good.vegan,
    excise: good.excise,
    marked: good.marked,
    weight: good.weight,
    measure: good.measure,
    weightdop: good.weightdop,
    measuredop: good.measuredop,
    description: good.description,
    allergens: good.allergens,
    priority: good.priority ? good.priority : 0,
    vat: good.vat ? good.vat : 'none',
    activeOnTime: good.activeOnTime,
    activeOnTimeStart: good.activeOnTimeStart,
    activeOnTimeEnd: good.activeOnTimeEnd,
    notIntegration: good.notIntegration ? good.notIntegration : false,
    activeOnWeekDays: good.activeOnWeekDays ? good.activeOnWeekDays : [true, true, true, true, true, true, true],
    proteins: good.proteins,
    carbs: good.carbs,
    fats: good.fats,
    kcal: good.kcal,
    hiddenClient: good.hiddenClient,
    equipment: good.equipment || {},
    typeMarked: good.typeMarked || optionsTypeMarked[0].value,
    gtin: good.gtin,
  } : {
    name: '',
    category: null,
    active: true,
    measure: 'gramm',
    priority: 0,
    vat: 'none',
    activeOnWeekDays: [true, true, true, true, true, true, true],
    notIntegration: false,
    hiddenClient: false,
    equipment: {},
    typeMarked: optionsTypeMarked[0].value,
    gtin: null,
  };
  const [data, setData] = useState(initData);
  const selectedMeasure = { value: data.measure, label: MEASURES[data.measure] };
  const selectedMeasureDop = { value: data.measuredop, label: MEASURES[data.measuredop] };
  const selectedVat = {value: data.vat, label: optionsVat.find((vat) => vat.value === data.vat).label};
  const selectedTypeMarked = data.typeMarked ? { value: data.typeMarked, label: optionsTypeMarked.find((type) => type.value === data.typeMarked).label } : optionsTypeMarked[0];
  const isEditMode = id !== 'new';
  const utcOffset = moment().utcOffset() / 60

  const onChangeInput = (field) => (e) => {
    const updated = {...data};
    updated[field] = e.target.value;
    setData(updated);
  };

  const onChangeNumberInput = (field) => (e) => {
    const updated = {...data};
    if(e.target.value.match(/^([0-9]{1,})?(\.)?([0-9]{1,})?$/)) {
      updated[field] = e.target.value;
      setData(updated);
    }
  };
  
  const onChangeEquipment = (field) => (e) => {
    const updated = {...data};
    const equipment = {...updated.equipment};
    if(e.target.value.match(/^([0-9]{1,})?(\.)?([0-9]{1,})?$/)) {
      equipment[field] = parseNumToFixed(e.target.value, 3);
      updated.equipment = equipment;
      setData(updated);
    }
  }

  const onChangeIntegration = (value) => {
    const updated = {
      ...data,
      notIntegration: value
    };
    setData(updated);
  };

  const onChangeSwitch = (field) => (value) => {
    const updated = {...data};
    updated[field] = value;
    
    setData(updated);
  };

  const onChangeCheckbox = (field) => (e) => {
    const updated = {...data};
    updated[field] = e.target.checked;
    setData(updated);
  };

  const onChangeActiveOnWeekDays = (index) => (e) => {
    const updated = {...data};
    updated.activeOnWeekDays[index] = e.target.checked;
    setData(updated);
  };

  const onSetFile = (field) => (e) => {
    const updated = {...data};
    updated[field] = e.target.files[0];
    setData(updated);
    if(field === 'secondImage')
      setDeleteSecondImage(false);
  };

  const isValid = () => {
    const { name, category, price, image, typeMarked, gtin } = data;
    if (typeMarked === 'horeca' && (!gtin || gtin === '')) return false;
    
    if (isEditMode) {
      if (name || image || category || price !== undefined) return true;
    }
    if (name && image && category && price !== undefined) return true;

    return false;
  }

  const onClose = () => !loader && dispatch(setActiveModalAction({ field: 'good', value: null }));
  useOnClickOutside(ref, onClose);

  const onSubmit = async (e) => {
    e.preventDefault();
    const rq = { ...data };
    if (rq.weight || rq.weight === '0') {
      rq.weight = parseFloat(rq.weight);
    }
    if (rq.weight === "") {
      rq.weight = null;
    }
    if (rq.weightdop || rq.weightdop === '0') {
      rq.weightdop = parseFloat(rq.weightdop);
    }
    if (rq.weightdop === "") {
      rq.weightdop = null;
    }
    if (rq.oldPrice || rq.oldPrice === '0') {
      rq.oldPrice = parseFloat(rq.oldPrice);
    } else {
      rq.oldPrice = null;
    }
    if (rq.price || rq.price === '0') {
      rq.price = parseFloat(rq.price);
    }
    if (!isEditMode) {
      const result = await dispatch(addGood(rq));
      if (result) {
        onClose();
        history.push(`/good/${result}`);
      }
    } else {
      if (rq.image) {
        rq.imageData = good.image;
      }
      if (rq.secondImage) {
        rq.secondImageData = good.secondImage;
      }
      if (rq.imageAgg) {
        rq.imageAggData = good.imageAgg;
      }
      dispatch(updateYumaposGoodMaps(id));
      const result = await dispatch(updateGood(id, rq));
      if(deleteSecondImage) {
        try {
            await request({ method: 'delete', url: `/upload/files/${deleteSecondImage}` });
        } catch (error) {
            console.log('Ошибка при удалении изображения:', error);
        }
      }
      if (result) {
        onClose();
      }
    }
  };

  const onChangeSelect = (field) => (value) => {
    const updated = {...data};
    if (field === 'measure' || field === 'measuredop' || field === 'vat' || field === 'typeMarked') {
      updated[field] = value.value;
    } else {
      updated[field] = value;
    }
    setData(updated);
  }

  const setFields = (fields) => {
    const updated = {...data};
    for (let field in fields) {
      updated[field] = fields[field];
    }
    setData(updated);
  }

  const setActive = (value) => {
    if(!value && !!data.activeOnTime) {
      const fields = {
        active: value,
        activeOnTime: false
      }
      setFields(fields)
    } else {
      onChangeSwitch('active')(value);
    }
  }

  const onChangeTime = (field) => (date) => {
    const newDate = moment.utc(date).add({ hours: utcOffset });
    return onChangeSwitch(field)(newDate);
  }

  const onDeleteSecondImage = (id) => (e) => {
    e.stopPropagation();    
    const updated = {...data};    
    updated.secondImage = null;
    setData(updated);
    setDeleteSecondImage(id);
  }
  
  return (
    <form onSubmit={onSubmit}>
      <div  className="modal fade show" style={{ display: 'block' }}>
        <div className="modal-dialog modal-lg modal-dialog-scrollable">
          <div ref={ref} className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{isEditMode ? 'Редактирование товара' : 'Добавление товара'} </h5>
              <button onClick={onClose} type="button" className="close">
              </button>
            </div>
            <div className="modal-body">
                <div className="form-group">
                  <label htmlFor="g-name" className="form-control-label">Заголовок *</label>
                  <input disabled={loader} type="text" value={data.name} className="form-control" id="g-name" onChange={onChangeInput('name')} />
                </div>

                <div className="form-group">
                  <label htmlFor="g-priority" className="form-control-label">Приоритет</label>
                  <input disabled={loader} type="number" value={data.priority} className="form-control" id="g-priority" onChange={onChangeInput('priority')} />
                </div>

                {id !== "new" && (
                  <YumaposGoodsMapInput 
                    id={id}
                    good={good}
                  />
                )}

                <div className="form-group">
                  <label htmlFor="g-name" className="form-control-label">Артикул (Frontpad)</label>
                  <input disabled={loader} type="text" value={data.article} className="form-control" id="g-name" onChange={onChangeInput('article')} />
                </div>

                <SelectCategories disabled={loader} selected={data.category} onChange={onChangeSelect('category')}/>
               
                <div className="form-group">
                  <label htmlFor="g-image" className="form-control-label">Изображение *</label>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {good && (
                      <img style={{ marginRight: '20px' }} width="100px" src={ getImageUrl(good.image) } alt="" />
                    )}
                    <input disabled={loader} onChange={onSetFile('image')} type="file" style={{ padding: '6px' }} className="form-control" id="g-image" />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="g-image" className="form-control-label">Изображение 2</label>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {good && (
                      <img style={{ marginRight: '20px' }} width="100px" src={ !deleteSecondImage ? getImageUrl(good.secondImage) : null } alt="" />
                    )}
                    <input disabled={loader} onChange={onSetFile('secondImage')} type="file" style={{ padding: '6px' }} className="form-control" id="g-image" />
                    {good && good.secondImage && !deleteSecondImage && (
                      <button type='button' className='btn btn-sm btn-clean btn-icon btn-icon-md' style={{ marginLeft: '5px' }} onClick={onDeleteSecondImage(good.secondImage.id)}><i className='flaticon2-trash'></i></button>
                    )}
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="g-image" className="form-control-label">Изображение для агрегаторов</label>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {good && (
                      <img style={{ marginRight: '20px' }} width="100px" src={ getImageUrl(good.imageAgg) } alt="" />
                    )}
                    <input disabled={loader} onChange={onSetFile('imageAgg')} type="file" style={{ padding: '6px' }} className="form-control" id="g-image" />
                  </div>
                </div>

                <div className='row'>
                  <div className='col-3' style={window.innerWidth <= 510 ? {flex: '0 0 50%', maxWidth: '50%'} : {}}>
                    <div className="form-group">
                      <label className="form-control-label">Цена *</label>
                      <input disabled={loader} type="number" value={data.price} className="form-control" onChange={onChangeNumberInput('price')} />
                    </div>
                  </div>
                  <div className='col-3' style={window.innerWidth <= 510 ? {flex: '0 0 50%', maxWidth: '50%'} : {}}>
                    <div className="form-group">
                      <label className="form-control-label">Старая цена</label>
                      <input disabled={loader} type="number" value={data.oldPrice} className="form-control" onChange={onChangeNumberInput('oldPrice')} />
                    </div>
                  </div>
                  {window.innerWidth > 510 && 
                  <>
                    <div className='col-3'>
                      <div className="form-group">
                        <label className="form-control-label">Вес/Объем</label>
                        <input disabled={loader} value={data.weight} className="form-control" onChange={onChangeNumberInput('weight')} />
                      </div>
                    </div>
                    <div className='col-3'>
                      <div className="form-group">
                        <label className="form-control-label">Единица</label>
                        <Select
                          value={selectedMeasure}
                          options={measureOptions}
                          onChange={onChangeSelect('measure')}
                          isClearable={false}
                          placeholder="Выберите единицу..."
                          disabled={loader}
                          styles={colourStyles}
                        />
                      </div>
                    </div>
                  </>
                  }
                </div>
                {window.innerWidth <= 510 &&
                <div className='row'>
                  <div className='col-3' style={window.innerWidth <= 510 ? {flex: '0 0 50%', maxWidth: '50%'} : {}}>
                      <div className="form-group">
                        <label className="form-control-label">Вес/Объем *</label>
                        <input disabled={loader} value={data.weight} className="form-control" onChange={onChangeNumberInput('weight')} />
                      </div>
                    </div>
                    <div className='col-3' style={window.innerWidth <= 510 ? {flex: '0 0 50%', maxWidth: '50%'} : {}}>
                      <div className="form-group">
                        <label className="form-control-label">Единица *</label>
                        <Select
                          value={selectedMeasure}
                          options={measureOptions}
                          onChange={onChangeSelect('measure')}
                          isClearable={false}
                          placeholder="Выберите единицу..."
                          disabled={loader}
                          styles={colourStyles}
                        />
                      </div>
                    </div>
                </div>
                }

                <div className='row'>
                  <div className='col-3' style={window.innerWidth <= 510 ? {flex: '0 0 50%', maxWidth: '50%'} : {}}>
                    <div className="form-group">
                      <label className="form-control-label">Вес/Объем (доп.)</label>
                      <input disabled={loader} value={data.weightdop} className="form-control" onChange={onChangeNumberInput('weightdop')} />
                    </div>
                  </div>
                  <div className='col-3' style={window.innerWidth <= 510 ? {flex: '0 0 50%', maxWidth: '50%'} : {}}>
                    <div className="form-group">
                      <label className="form-control-label">Единица (доп.)</label>
                      <Select
                         value={selectedMeasureDop}
                         options={measureOptions}
                         onChange={onChangeSelect('measuredop')}
                         isClearable={false}
                         placeholder="Выберите единицу..."
                         disabled={loader}
                         styles={colourStyles}
                      />
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col-3' style={window.innerWidth <= 510 ? {flex: '0 0 50%', maxWidth: '50%'} : {}}>
                    <div className="form-group">
                      <label className="form-control-label">Кол-во соевых соусов шт.</label>
                      <input disabled={loader} value={(data && data.equipment && data.equipment.souce) ? parseNumToFixed(data.equipment.souce, 3) : 0} className="form-control" onChange={onChangeEquipment('souce')} />
                    </div>
                  </div>
                  <div className='col-3' style={window.innerWidth <= 510 ? {flex: '0 0 50%', maxWidth: '50%'} : {}}>
                    <div className="form-group">
                      <label className="form-control-label">Кол-во имбиря гр.</label>
                      <input disabled={loader} value={(data && data.equipment && data.equipment.ginger) ? parseNumToFixed(data.equipment.ginger, 3) : 0} className="form-control" onChange={onChangeEquipment('ginger')} />
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col-3' style={window.innerWidth <= 510 ? {flex: '0 0 50%', maxWidth: '50%'} : {}}>
                    <div className="form-group">
                      <label className="form-control-label">Кол-во васаби гр.</label>
                      <input disabled={loader} value={(data && data.equipment && data.equipment.wasabi) ? parseNumToFixed(data.equipment.wasabi, 3) : 0} className="form-control" onChange={onChangeEquipment('wasabi')} />
                    </div>
                  </div>
                </div>

                <div className='row' style={{ flexDirection: 'column', gap: '5px'}}>
                  <div className='col-3' style={window.innerWidth <= 510 ? {flex: '0 0 50%', maxWidth: '50%'} : {}}>
                    <div className="form-group">
                      <label className="form-control-label">НДС</label>             
                      <Select
                          closeMenuOnSelect={true}
                          options={optionsVat.filter((vat) => vat.value !== 'goods')}
                          onChange={onChangeSelect('vat')}
                          value={selectedVat}
                          placeholder="НДС..."
                          disabled={loader}
                         styles={colourStyles}
                      />
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-control-label">Описание</label>
                  <textarea minLength={3} maxLength={500} disabled={loader} value={data.description} className="form-control" onChange={onChangeInput('description')} />
                </div>

                <div className="form-group">
                  <label className="form-control-label">Аллергены</label>
                  <textarea minLength={3} maxLength={500} disabled={loader} value={data.allergens} className="form-control" onChange={onChangeInput('allergens')} />
                </div>

                <div className='kt-separator kt-separator--border-dashed kt-separator--space-md'/>

                <label style={{ color: 'black' }}>Кбжу на 100гр:</label>
                <div className='row'>                  
                  <div className='col-3' style={window.innerWidth <= 510 ? {flex: '0 0 50%', maxWidth: '50%'} : {}}>
                    <div className="form-group">
                      <label className="form-control-label">Ккал</label>
                      <input disabled={loader} type="number" step='any' min={0} value={data.kcal} className="form-control" onChange={onChangeNumberInput('kcal')} />
                    </div>
                  </div>
                  <div className='col-3' style={window.innerWidth <= 510 ? {flex: '0 0 50%', maxWidth: '50%'} : {}}>
                    <div className="form-group">
                      <label className="form-control-label">Белки</label>
                      <input disabled={loader} type="number" step='any' min={0} value={data.proteins} className="form-control" onChange={onChangeNumberInput('proteins')} />
                    </div>
                  </div>
                  {window.innerWidth > 510 && 
                  <>
                    <div className='col-3'>
                      <div className="form-group">
                        <label className="form-control-label">Жиры</label>
                        <input disabled={loader} type="number" step='any' min={0} value={data.fats} className="form-control" onChange={onChangeNumberInput('fats')} />
                      </div>
                    </div>
                    <div className='col-3'>
                      <div className="form-group">
                        <label className="form-control-label">Углеводы</label>
                        <input disabled={loader} type="number" step='any' min={0} value={data.carbs} className="form-control" onChange={onChangeNumberInput('carbs')} />
                      </div>
                    </div>
                  </>
                  }
                </div>
                {window.innerWidth <= 510 &&
                  <div className='row'>
                    <div className='col-3' style={window.innerWidth <= 510 ? {flex: '0 0 50%', maxWidth: '50%'} : {}}>
                        <div className="form-group">
                          <label className="form-control-label">Жиры</label>
                          <input disabled={loader} type="number" step='any' min={0} value={data.fats} className="form-control" onChange={onChangeNumberInput('fats')} />                          </div>
                      </div>
                      <div className='col-3' style={window.innerWidth <= 510 ? {flex: '0 0 50%', maxWidth: '50%'} : {}}>
                        <div className="form-group">
                          <label className="form-control-label">Углеводы</label>
                          <input disabled={loader} type="number" step='any' min={0} value={data.carbs} className="form-control" onChange={onChangeNumberInput('carbs')} />
                        </div>
                      </div>
                  </div>
                }

                <div className='kt-separator kt-separator--border-dashed kt-separator--space-md'/>

                <div className="form-group">
                    <label className="form-control-label">Параметры товара</label>
                    <div className="kt-checkbox-inline" style={{ marginTop: '5px' }}>
                        <label className="kt-checkbox">
                            <input disabled={loader} type="checkbox" checked={!!data.hot} onChange={onChangeCheckbox('hot')}/> Острое
                            <span></span>
                        </label>
                        <label className="kt-checkbox">
                            <input disabled={loader} type="checkbox" checked={!!data.vegan} onChange={onChangeCheckbox('vegan')}/> Веган
                            <span></span>
                        </label>
                        <label className="kt-checkbox">
                            <input disabled={loader}  type="checkbox" checked={!!data.recomended} onChange={onChangeCheckbox('recomended')}/> Рекомендуем
                            <span></span>
                        </label>
                        <label className="kt-checkbox">
                            <input disabled={loader}  type="checkbox" checked={!!data.gift} onChange={onChangeCheckbox('gift')}/> Подарок
                            <span></span>
                        </label>
                    </div>
                </div>
                <div className="form-group row" style={{ marginBottom: 0 }}>
                    <label className="col-xl-3 col-lg-3 col-form-label">Включен</label>
                    <div className="col-lg-9 col-xl-9">
                        <Switch disabled={loader} nomargin={true} onChange={(value) => setActive(value)} checked={!!data.active}/>
                    </div>
                </div>
                <div className="form-group row" style={{ marginBottom: 0 }}>
                    <label className="col-xl-3 col-lg-3 col-form-label">Скрыт для клиентов</label>
                    <div className="col-lg-9 col-xl-9">
                        <Switch disabled={loader} nomargin={true} onChange={onChangeSwitch('hiddenClient')} checked={!!data.hiddenClient}/>
                    </div>
                </div>
                <div className='kt-separator kt-separator--border-dashed kt-separator--space-md'></div>
                <div className="form-group row" style={{ marginBottom: '1rem' }}>
                    <label className="col-xl-3 col-lg-3 col-form-label">Маркированный товар</label>
                    <div className="col-lg-9 col-xl-9">
                        <Switch disabled={loader} nomargin={true} onChange={onChangeSwitch('marked')} checked={data.marked}/>
                    </div>
                </div>
                {data.marked &&
                  <>
                  <div className="form-group">
                      <label htmlFor="g-category" className="form-control-label">Режим работы с маркировкой *</label>
                      <Select
                        value={selectedTypeMarked}
                        options={optionsTypeMarked}
                        onChange={onChangeSelect('typeMarked')}
                        isClearable={false}
                        placeholder="Выберите режим..."
                        disabled={loader}
                        styles={colourStyles}
                      />
                  </div>
                  {data.typeMarked === 'horeca' && 
                    <div className="form-group">
                      <label className="form-control-label">GTIN *</label>
                      <input disabled={loader} type="text" value={data.gtin} className="form-control" id="g-name" onChange={onChangeInput('gtin')} />
                    </div>
                  }
                  </>
                }
                <div className='kt-separator kt-separator--border-dashed kt-separator--space-md'></div>
                <div className="form-group row" style={{ marginBottom: 0 }}>
                    <label className="col-xl-3 col-lg-3 col-form-label">Акцизный товар</label>
                    <div className="col-lg-9 col-xl-9">
                        <Switch disabled={loader} nomargin={true} onChange={onChangeSwitch('excise')} checked={data.excise}/>
                    </div>
                </div>
                {data.active && <div className="form-group row" style={{ marginBottom: 0 }}>
                    <label className="col-xl-3 col-lg-3 col-form-label">Интегрировать в агрегаторы</label>
                    <div className="col-lg-9 col-xl-9">
                        <Switch nomargin={true} onChange={(value) => onChangeIntegration(!value)} checked={!data.notIntegration}/>
                    </div>
                </div>}
                <div className="form-group row" style={{ marginBottom: 0 }}>
                    <label className="col-xl-3 col-lg-3 col-form-label">Включение по времени</label>
                    <div className="col-lg-9 col-xl-9">
                        <Switch disabled={!data.active} nomargin={true} onChange={onChangeSwitch('activeOnTime')} checked={!!data.activeOnTime}/>
                    </div>
                </div>
                <div className="form-group row" style={{ marginBottom: 0 }}>
                    <label className="col-xl-3 col-lg-3 col-form-label">Доступно с</label>
                    <div className="col-lg-9 col-xl-9">
                        <TimeInput
                          placeholderText="Начало времени"
                          disabled={!data.activeOnTime}
                          selected={data.activeOnTimeStart ? moment(data.activeOnTimeStart).subtract({ hours: utcOffset }).toDate() : moment().toDate()}
                          onChange={onChangeTime('activeOnTimeStart')}
                          className="form-control"
                        />
                    </div>
                </div>
                <div className="form-group row" style={{ marginBottom: 0 }}>
                    <label className="col-xl-3 col-lg-3 col-form-label">Доступно до</label>
                    <div className="col-lg-9 col-xl-9">
                        <TimeInput 
                          placeholderText="Окончание времени"
                          disabled={!data.activeOnTime}
                          selected={data.activeOnTimeEnd ? moment(data.activeOnTimeEnd).subtract({ hours: utcOffset }).toDate() : moment().toDate()}
                          onChange={onChangeTime('activeOnTimeEnd')}
                          className="form-control"
                        />
                    </div>
                </div>
                <div className='kt-separator kt-separator--border-dashed kt-separator--space-md'></div>
                <div className="form-group row">
                    <label className="col-xl-3 col-lg-3 col-form-label">Включение по дням недели</label>
                    <div className='kt-checkbox-inline'>
                      {daysWeek.map((day) => (
                        <label className="kt-checkbox">
                          <input disabled={loader} type="checkbox" checked={data.activeOnWeekDays ? data.activeOnWeekDays[day.value] : true} onChange={onChangeActiveOnWeekDays(day.value)}/>
                          {day.label}
                          <span></span>
                      </label>
                      ))}
                    </div>
                </div>
                <ErrorContainer field="modalGood" hasCloseButton={true}/>
            </div>

            <div className="modal-footer">
              <button disabled={loader} type="button" className="btn btn-secondary" onClick={onClose}>Отмена</button>
              <button
                type="submit"
                disabled={!isValid() || loader}
                className={cn({ 'btn btn-primary  kt-spinner--right kt-spinner--sm kt-spinner--light': true, 'kt-spinner': loader })}>
                  {isEditMode ? 'Сохранить' : 'Добавить товар'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}

export default withRouter(GoodModal);